import { JSX } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ClassValue } from "clsx";

import { cn } from "../../utils/cn";
import GetHeroIcon from "../../utils/getHeroIcons";

interface Props {
  open: boolean;
  setOpen?: { (value: boolean): void };
  children: string | JSX.Element | JSX.Element[] | (() => JSX.Element);
  width?: boolean;
  childDialogTitle?: string;
  titleClass?: ClassValue;
  dialogueClassName?: ClassValue;
  animate?: boolean;
  closeBtn?: boolean;
}

const Modal = ({
  open,
  setOpen,
  children,
  childDialogTitle,
  titleClass,
  dialogueClassName,
  animate = false,
  closeBtn = false,
}: Props) => {
  const animateClassName = animate ? " animate-slideDown " : " ";
  return (
    <Transition.Root show={open} as={undefined}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={(value: boolean) => {
          setOpen && setOpen(value);
        }}
      >
        <Transition.Child
          as={undefined}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex h-full justify-center p-4 text-center items-center sm:p-0">
            <Transition.Child
              as={undefined}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={cn(
                  "relative transform rounded-lg bg-bkg p-4 lg:pb-4 lg:pt-5 text-left shadow-xl transition-all my-8 w-full lg:p-6 max-w-[90%]",
                  dialogueClassName,
                  animateClassName
                )}
              >
                <div className="flex justify-between mb-2 ">
                  <div>
                    <h2 className={cn("font-semibold text-xl", titleClass)}>
                      {childDialogTitle}
                    </h2>
                  </div>
                  {!closeBtn && (
                    <div data-testid="closeModalIcon">
                      <GetHeroIcon
                        name="XMarkIcon"
                        className="w-6 h-6 flex-shrink-0 font-bold cursor-pointer text-secondary"
                        aria-hidden="true"
                        onClick={() => {
                          setOpen && setOpen(false);
                        }}
                      />
                    </div>
                  )}
                </div>

                <>{children}</>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default Modal;
